import Loadable from '../../components/Loadable/Loadable'
import React, { lazy } from 'react'
import { Page } from '../../Pages'
import { ShowIfRole } from '../../auth/AuthGuard'

const CostAllocationPage = Loadable(lazy(() => import('./CostAllocationPage')))

const constAllocationRoutes = [
	{
		path: Page.constAllocation.path,
		element: (
			<ShowIfRole role={Page.constAllocation.auth}>
				<CostAllocationPage />
			</ShowIfRole>
		),
		auth: Page.constAllocation.auth
	}
]

export default constAllocationRoutes
